import { render, staticRenderFns } from "./specialProducts.vue?vue&type=template&id=074a930a&scoped=true&"
import script from "./specialProducts.vue?vue&type=script&lang=js&"
export * from "./specialProducts.vue?vue&type=script&lang=js&"
import style0 from "./specialProducts.vue?vue&type=style&index=0&id=074a930a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074a930a",
  null
  
)

export default component.exports